<template>
  <div class="list-header">
    <div class="content flex-content-between">
      <div class="left flex-row-center">
        <h2 @click="goSelectPage">{{ testName }}线上阅卷</h2>
      </div>
      <div class="right flex-row-center">
        <p class="item record" @click="openRecord"><i class="icon-record"></i>阅卷记录</p>
        <p class="item">
          <i class="icon-progress"></i>阅卷进度：
          <el-progress class="progress" :percentage="percentage" :stroke-width="6" color="#FFD944" :show-text="false"></el-progress>
          <span class="text">{{ completeCount  }}/{{ assignCount }}</span>
        </p>
        <div
          class="avatar"
          :style="{'background-image': `url('${user.avatar_url}')`}">
          <ul class="user-list">
            <li>{{ account }}</li>
            <li class="logout" @click="logout">退出登录</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Progress } from 'element-ui'
import { mapState } from 'vuex'
export default {
  components: {
    ElProgress: Progress
  },
  props: {
    completeCount: {
      type: Number
    },
    assignCount: {
      type: Number
    }
  },
  data() {
    return {
      testName: '',
      account: ''
    }
  },
  computed: {
    ...mapState(['user']),
    percentage() {
      if (this.assignCount > 0) {
        return this.completeCount / this.assignCount * 100
      } else {
        return 0
      }
    }
  },
  mounted() {
    this.account = localStorage.currentPhone
    this.testName = this.$route.query.name
  },
  methods: {
    openRecord() {
      const { id, name, judgeId } = this.$route.query
      this.$router.push({ name: 'judgeRecord', query: { id: id, name: name, judgeId: judgeId } })
    },
    async logout () {
      await this.$store.dispatch('logout')
      localStorage.clear()
      if (window.location.href.indexOf(CONFIG.noc2024) === -1) {
        this.$router.push({ name: 'login' })
      }
    },
    goSelectPage() {
      this.$router.push({ name: 'judgeSelect' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .list-header {
    height: 64px;
    background-color: $themeColor;
    padding: 0 40px 0 60px;
  }
  .content {
    align-items: center;
    height: 100%;
  }
  .left {
    h2 {
      font-size: 22px;
      color: #fff;
      line-height: 30px;
      cursor: pointer;
    }
  }
  .right {
    font-size: 14px;
    color: #fff;
    .item {
      display: flex;
      align-items: center;
    }
    i {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 3px;
    }
    .record {
      margin-right: 50px;
      cursor: pointer;
    }
    .progress {
      width: 200px;
      margin-right: 10px;
    }
    .text {
      font-size: 12px;
    }
  }
  .icon-record {
    background: url("~@/assets/images/judge/icon-record.png") center / cover no-repeat;
  }
  .icon-progress {
    background: url("~@/assets/images/judge/icon-progress.png") center / cover no-repeat;
  }
  .avatar {
    z-index: 1;
    position: relative;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    background: url('~@/assets/images/icon_user.png') no-repeat center / cover;
    margin-left: 40px;
    &:hover {
      .user-list {
        visibility: visible;
        opacity: 1;
      }
    }
    .user-list {
      width: 150px;
      position: absolute;
      background: #fff;
      top: 50px;
      left: -74px;
      box-shadow: 0 6px 8px 0 rgba(0,0,0,0.12);
      border-radius: 0 0 4px 4px;
      visibility: hidden;
      // padding-bottom: 15px;
      opacity: 0;
      transition: all .3s;
      li {
        color: #555;
        font-size: 14px;
        line-height: 44px;
        font-weight: 400;
        letter-spacing: 0;
        text-align: center;
        white-space: nowrap;
      }
      .logout {
        border-top: 1px solid #eee;
        height: 53px;
        line-height: 53px;
        cursor: pointer;
        letter-spacing: 1px;
        font-size: 16px;
        &:hover {
          background: rgba(48, 110, 255, 0.05);
          color: $themeColor;
        }
      }
    }
  }
</style>
